<template>
    <article v-if="pending">
        <content-placeholders
            v-for="i in [0,1,2,3,4,5,6,7,8,9]"
            :key="i"
            style="margin-top: var(--spacing-xl);"
        >
            <content-placeholders-heading />
            <br><br>
            <content-placeholders-text :lines="6" />
            <content-placeholders-img />
            <content-placeholders-text :lines="3" />
            <br><br>
            <content-placeholders-text :lines="10" />
        </content-placeholders>
    </article>

    <div v-else-if="chapter && !error">
        <!-- eslint-disable vue/no-v-html -->
        <BaseGuidelineText
            ref="guideline-text"
            :content="chapterContent"
            :chapter-id="chapterId"
            @open-note="openNote"
        />
        <transition name="fade">
            <BaseGuidelineReferenceTooltip
                v-if="activeNoteNames"
                :guideline-id="guideline?.id"
                :names="activeNoteNames"
                @close="activeNoteNames = null"
            />
        </transition>
    </div>

    <div v-else>
        <h2>Not found</h2>
        <p>Sorry, this guideline chapter could not be found.</p>
    </div>
</template>

<script setup lang="ts">
import GuidelineChapterQuery from '~/graphql/queries/guidelines/chapter.graphql';

import {useGuidelineSearchStore} from '~/store/guideline-search';

const props = defineProps({
    guideline: {
        type: Object,
        required: false,
        default: null
    }
});

const {
    // searchQuery,
    currentChapterContent,
    // currentHighlightNumber,
    // currentChapterHighlightCount,
    // isFirstHighlightInChapter,
    // highlightOffset
} = storeToRefs(useGuidelineSearchStore());

const activeNoteNames = ref<null | string[]>(null);

const chapterId = computed(() => {
    return Number(chapter?.value?.id);
});

function openNote({ numbers }:{
    numbers: number[]
}) {
    if (numbers) {
        activeNoteNames.value = numbers.map(number => `note_${number}`);
    } else {
        activeNoteNames.value = null;
    }
}

const route = useRoute();
const variables = ref({
    guidelineId: Number(props.guideline?.id),
    slug: route.params.chapterSlug
});

// We don't need the URI for this query
const { data, pending, error } = await useLazyAsyncQuery({
    query: GuidelineChapterQuery,
    variables
});

const chapter = computed(() => {
    if (!data.value?.chapter) {
        return null;
    }

    return data?.value?.chapter;
});


const chapterContent = computed(() => {
    const searchChapter = currentChapterContent.value;

    if (searchChapter) {
        return searchChapter;
    }

    return chapter?.value?.chapterContent;
});

const chapterSlug = computed(() => route.params.chapterSlug);

watch(
    () => chapterSlug,
    (newSlug) => {
        variables.value.slug = newSlug;
    },
    { immediate: true }
);

// watch('route.params.chapterSlug', async() => {
//     variables.chapterSlug = route.params.chapterSlug;
// }, {
//     immediate: true,
// });

watch(
    () => props.guideline,
    () => {
        variables.value.guidelineId = Number(props.guideline?.id);
    },
    { immediate: true, deep: true }
);
</script>
